<template>
  <BaseSkeleton
    v-if="isLoading"
    :type="skeleton ? skeleton : 'avatar'"
    :class="classes"
    v-bind="$attrs"
  />
  <v-icon
    v-else
    class="base-icon"
    :class="classes"
    v-bind="$attrs"
  >
    {{ $attrs.name }}
  </v-icon>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BaseComponent from '../BaseComponent/BaseComponent.vue';
import BaseSkeleton from '@/shared/lib/uikit/components/BaseSkeleton/BaseSkeleton.vue';

export default defineComponent({
  name: 'BaseIcon',
  components: { BaseSkeleton },
  extends: BaseComponent,
});
</script>

<style lang="scss" scoped>
body .v-icon.base-icon {
  &.variant {
    &__coin {
      width: rem(34);
      height: rem(24);
      background: center center no-repeat url('~@project/assets/img/order/icon-coin.svg');
    }

    &__coin-mosap {
      width: rem(28);
      height: rem(25);
      background: center center no-repeat url('~@project/assets/img/order/icon-coin.svg');
    }

    &__one-coin {
      width: rem(20);
      height: rem(20);
      background: center center no-repeat url('~@project/assets/img/profile/icons/icon-token.svg');
    }

    &__one-coin-mosap {
      width: rem(25);
      height: rem(25);
      background: center center no-repeat url('~@project/assets/img/profile/icons/icon-token.svg');
    }

    &__arrow {
      width: rem(12);
      height: rem(8);
      background: #000;
      mask: center center no-repeat url('@/shared/assets/img/_common/arrow.svg');
    }

    &__slider-arrow {
      width: rem(46);
      height: rem(46);
      background: #000;
      mask: center center no-repeat url('@/shared/assets/img/_common/slider-arrow.svg');
    }

    &__arrow-left {
      width: rem(8);
      height: rem(14);
      background: #000;
      mask: center center no-repeat url('@/shared/assets/img/_common/arrow-left.svg');
    }

    &__info {
      width: rem(20);
      height: rem(20);
      background: #000;
      background: 0 0 no-repeat url('@/shared/assets/img/profile/icons/icon-info.svg');
    }

    &__info-danger {
      width: rem(22);
      height: rem(22);
      background: #000;
      background: 0 0 no-repeat url('@/shared/assets/img/_common/email_alert.svg');
    }

    &__info-disabled {
      width: rem(22);
      height: rem(22);
      background: #000;
      background: 0 0 no-repeat url('@/shared/assets/img/profile/icons/icon-info-disabled.svg');
    }

    &__ruble {
      width: rem(16);
      height: rem(18);
      background: #000;
      background: 0 0 no-repeat url('@/shared/assets/img/_common/ruble.svg');
    }

    &__ruble-accent {
      width: rem(16);
      height: rem(18);
      background: #000;
      background: 0 0 no-repeat url('@/shared/assets/img/_common/ruble-accent.svg');
    }

    &__map-point {
      width: rem(16);
      height: rem(16);
      background: #000;
      background: 0 0 no-repeat url('@/shared/assets/img/profile/icons/icon-map-point.svg');
    }

    &__edit {
      width: rem(17);
      height: rem(17);
      background: #000;
      background: 0 0 no-repeat url('~@project/assets/img/profile/icons/icon-change.svg');
    }

    &__asterisk {
      width: rem(10);
      height: rem(10);
      background: var(--pageErrorFont);
      mask: center center no-repeat url('@/shared/assets/img/_common/asterisk.svg');
    }

    &__close {
      width: rem(32);
      height: rem(32);
      background: var(--pageFont);
      mask: center center no-repeat url('@/shared/assets/img/_common/close-big.svg');
    }

    &__success {
      width: rem(22);
      height: rem(23);
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAXCAYAAAAP6L+eAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAIrSURBVHgBpVXPSxtBFP5msoi3bouHFnJYpS20l8bSU21x1x5a6CX9C1zotWC8VVtwA7U/oFDyF5hA720PLb3UjQXBk3rwKGYVQW9G8CBRs755m5hEdze/PpjJ7Js33/vmzZuJQDu4jg5UDEDqDaO2Dsspxy0T0YTv08DZFLmY4Q5+EVLmMT5f6IzYnU1Rv0Athc7gAQMW7cBrNspW0neT1K91QapgUKpKWOK1F2godmdo6+IH+oEUdj01AbHrGBRVKdXRH+hAB0ZVWmqpqMz1Qqprg9yaTcDJQqA4UFtClzAGr8NNvebx8MrXS7PSIsWVDHrAt9svmbxYDtNUNYnYf4AuMZUcQ3roHrzjA2S9fyEeYpyIxZXSUnlbe/SGVV2GUukYEzx2vEUiD7uAfkpDxKEpgkzyFo+nN39f2FVeVeD8/ioK1CKgyzBr+fQYrza+8ziTfExtjMdzxjMOGJ2CBhKwn9phqtUWt6mlh+7jxY07HOzzyPMg2OYfLJVjC2mdiJ+MhuWZZ4/2+AaZ+giR32VbbncZX3b+IxYCfykViXycjzogRRbs4oC/28L3f9Wu9KzalxHna998SDW7FVEFLfBgfRyuHZ6cbuetqqADUvUQOfzDH9aHn9Tn0DequdbXrY7FmTyEmERPEEVY81b9q7WOJz7Z1GfRNUhpEymHCfVz3xpULfT8+SbQRiVEllJZvDITu44DSJMUUZ0nrgXGs0NIrYSqVoj7pz4H0nisCZKDSx8AAAAASUVORK5CYII=');
    }

    &__rocket {
      width: rem(30);
      height: rem(31);
      background-position: 0 0;
      background-repeat: no-repeat;
      background-size: contain;
      background-image: url('data:image/png;base64,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');
    }

    &__plus {
      width: rem(19);
      height: rem(20);
      background: var(--pageFont);
      mask: center center no-repeat url('@/projects/mti/assets/img/faq/plus.svg');
    }

    &__minus {
      width: rem(19);
      height: rem(2);
      background: var(--pageFont);
      mask: center center no-repeat url('@/projects/mti/assets/img/faq/minus.svg');
    }

    &__plus-mosap {
      width: rem(19);
      height: rem(20);
      background-image: url('@/projects/mosap/assets/img/faq/plus.svg');
    }

    &__minus-mosap {
      width: rem(19);
      height: rem(20);
      background-image: url('@/projects/mosap/assets/img/faq/minus.svg');
      margin-top: 16px;
    }

    &__alert {
      width: rem(22);
      height: rem(22);
      background: transparent;
      font-size: rem(22);

      &::before {
        content: "\F0026";
        font: normal normal normal 24px/1 "Material Design Icons";
        color: var(--pageErrorFont);
        animation: color-blink 1s linear infinite;
      }
    }
  }

  &.place {
    &__order-card-info {
      width: rem(20);
      height: rem(20);
      background: #000;
      position: absolute;
      display: block;
      min-width: auto;
      top: rem(0);
      right: rem(-22);
      background: 0 0 no-repeat url('@/shared/assets/img/_common/info.svg');
    }
  }
}

@if mixin-exists("ThemeBaseIcon") {
  @include ThemeBaseIcon;
}

@keyframes color-blink {
  100% {
    color: var(--blockGhostFont)
  }

  50% {
    color: var(--pageErrorFont);
  }

  0% {
    color: var(--blockGhostFont)
  }
}
</style>
